import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * External dependencies
 */
import { useContext, useEffect, useState } from 'react';
import Select, { components } from 'react-select';
const { Option } = components;
import { SET_FILTERING, store } from '../state/state';
import Icon from './Icon';
// @link https://codesandbox.io/s/custom-visible-multivalues-8zh8c?file=/example.js:366-597
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const MoreSelectedBadge = ({ items, label }) => {
    const title = items.join(', ');
    const count = items.length;
    return (_jsxs("div", { className: "flex items-center space-x-2", title: title, children: [_jsx("div", { className: "font-semibold text-green-600 text-body leading-tighter", children: label }), _jsx("div", { className: "absolute right-0 flex items-center justify-center w-6 h-6 font-semibold leading-none text-white rounded-full text-body-small bg-green", children: count })] }));
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const MultiValue = ({ index, getValue, ...props }) => {
    const maxToShow = 0;
    const overflow = getValue()
        .slice(maxToShow)
        .map((x) => x.value);
    return index === maxToShow ? (_jsx(MoreSelectedBadge, { items: overflow, label: props.selectProps.placeholder })) : null;
};
const IconOption = (props) => (_jsx(Option, { ...props, children: _jsxs("span", { className: "flex items-center justify-between", children: [_jsx("span", { children: props.data.label }), _jsx("span", { className: "w-6 h-6", children: props.isSelected ?
                    _jsx("span", { className: "text-green", children: _jsx(Icon, { name: "circle-tick" }) }) :
                    _jsx("span", { className: "text-grey-50", children: _jsx(Icon, { name: "circle" }) }) })] }) }));
const customStyles = {
    control: (provided, state) => ({
        display: 'flex',
        alignItems: 'center',
        color: state.isFocused ? '#5A7433' : '#789B44',
        height: '1.75rem',
        width: '100%'
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#96C255',
        marginLeft: '0.5rem',
        padding: 0
    }),
    indicatorSeparator: (provided, state) => ({
        ...provided,
        display: 'none'
    }),
    input: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0
    }),
    menu: (provided, state) => ({
        ...provided,
        border: 0,
        borderTop: '0.25rem solid #96C255',
        borderRadius: 0,
        margin: '1.5rem 0 0 0',
        minWidth: '19rem',
        padding: 0,
        zIndex: 9999
    }),
    menuList: (provided, state) => ({
        ...provided,
        borderLeft: '1px solid #E2E2DD',
        borderRight: '1px solid #E2E2DD',
        borderBottom: '1px solid #E2E2DD',
        borderRadius: 0,
        margin: 0,
        padding: '0.5rem 1.5rem'
    }),
    menuPortal: (provided, state) => ({
        ...provided,
        zIndex: 9999
    }),
    option: (provided, state) => {
        const lastOption = state.options[state.options.length - 1];
        return {
            ...provided,
            background: '#fff',
            borderBottom: lastOption.label === state.label ? 0 : '1px solid #E2E2DD',
            color: state.isSelected ? '#000' : '#777771',
            cursor: 'pointer',
            fontFamily: 'Poppins',
            fontWeight: 600,
            letterSpacing: '-0.01em',
            padding: '1rem 0',
            position: 'relative'
        };
    },
    placeholder: (provided, state) => ({
        ...provided,
        color: state.isFocused ? '#5A7433' : '#789B44',
        fontFamily: 'Poppins',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        margin: 0,
        padding: 0
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: '#5A7433',
        fontFamily: 'Poppins',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        margin: 0,
        padding: 0
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        position: 'static',
        padding: 0
    })
};
const FiltersDropdown = ({ options, placeholder, onChange, name, defaultValue, isMulti = false }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const globalState = useContext(store);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { dispatch } = globalState;
    useEffect(() => {
        dispatch({
            type: SET_FILTERING,
            filtering: menuIsOpen
        });
    }, [menuIsOpen]);
    const onFocus = () => {
        setMenuIsOpen(true);
    };
    const onBlur = () => {
        setMenuIsOpen(false);
    };
    // .react-select__menu
    // .react-select__control
    // .react-select__single-value
    // .react-select__menu-list
    // .react-select__placeholder
    return (_jsx("div", { children: _jsx(Select, { classNamePrefix: "react-select", styles: customStyles, options: options, name: name, isSearchable: false, onMenuOpen: onFocus, onMenuClose: onBlur, placeholder: placeholder, onChange: onChange, onFocus: onFocus, onBlur: onBlur, isMulti: isMulti, hideSelectedOptions: false, minMenuHeight: 160, closeMenuOnSelect: !isMulti, defaultValue: defaultValue, components: { MultiValue, Option: IconOption } }) }));
};
export default FiltersDropdown;
